<template>

  <t-page>

    <TypeRawMaterialDialog :no-option-add="noOptionAdd" @onSubmit="onTypeRawMaterialDialog"/>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #default="{status}">

        <t-input v-model="form.rawMaterialId" hidden/>

        <t-form-card title="Dados Básicos">

          <b-row>

            <t-input v-model="form.name"  :add-error="error.name" label="Descrição" cols="9" required/>

            <t-input v-model="form.rawMaterialCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                     :add-error="error.rawMaterialCodeLabel" upper cols="3"
                     label="Cód. Matéria-Prima"
                     code-label
                     help="Código inserido manualmente conforme configurado em Produtos > Configurações > Parâmetros"
                     required/>

            <t-input v-model="form.rawMaterialCodeLabel"
                     v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                     :add-error="error.rawMaterialCodeLabel" upper cols="3"
                     fixed
                     label="Cód. Matéria-Prima"
                     help="Código inserido automaticamente conforme configurado em Produtos > Configurações > Parâmetros"
            />



          </b-row>

          <t-input v-model="form.typeRawMaterialId"
                   :options="typeRawMaterialOptions"
                   label="Tipo de Matéria-Prima" select required>

            <template #no-options="{search}">
              <b-link @click="addNoOption('modal-type-raw-material',search)">Cadastrar Tipo</b-link>
            </template>

            <template #input-group-append>
              <t-button title="Adicionar novo tipo" @click="openDialogForm('modal-type-raw-material')"
                        icon-plus/>
            </template>

          </t-input>

          <t-input v-model="form.measureId" label="Tipo de Medida" :options="typeMeasureOptions" select required/>

          <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
          <t-page-form-field-customized
              ref="fieldsGeneral"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('page')"
              :primary-key="form.instrumentId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
              :primary-key-column="fieldKey" foreign-key-column="pageId"
          />

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-card>

        <t-form-card title="Grupos de produtos" icon-folder>

          <b-form-checkbox class="col-sm-12 ml-2" v-model="form.availableAllGroups" switch>
            Disponibilizar esta matéria-prima a todos os grupos de produtos?
            <t-help
                title="Você poderá especificar quais os produtos podem utilizar esta matéria-prima, basta desmarcar esta opção e selecionar os grupos de produtos desejados."/>
          </b-form-checkbox>

          <div v-show="!form.availableAllGroups" class="mt-2">

            <div v-for="family in groupProductOptions" :key="family.groupId" class="pb-2 mb-2 border-bottom">

              <h6 class="mb-0"><b>{{ family.groupLabel }}</b></h6>

              <div class="mb-2">
                <small>
                  <b-link @click="selectGroup(true,family.options)">Todos</b-link>
                  |
                  <b-link @click="selectGroup(false,family.options)">Nenhum</b-link>
                </small>
              </div>

              <b-form-checkbox class="ml-3" v-for="item in family.options" :key="item.value"
                               :checked="form.groupsProduct.find(a => a.groupProductId === item.value) != null"
                               @change="addGroupSelected($event,item.value)">
                {{ item.text }}
              </b-form-checkbox>

            </div>

          </div>

        </t-form-card>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import TypeRawMaterialDialog from "@/views/modules/product/TypeRawMaterialDialog"
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import groupProductService from "@/services/modules/product/GroupProduct.service";
import typeMeasureService from "@/services/modules/general/TypeMeasure.service";
import typeRawMaterialService from "@/services/modules/product/TypeRawMaterial.service";

import ui from "@/assets/scripts/ui";
import SettingType from "@/model/types/resource/SettingType";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'RawMaterialForm',
  components: {TypeRawMaterialDialog},
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "rawMaterialId",
      form: {
        rawMaterialId: 0,
        typeRawMaterialId: 0,
        rawMaterialCodeLabel: "",
        name: "",
        measureId: 0,
        note: "",
        availableAllGroups: true,
        groupsProduct: [],
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        rawMaterialCodeLabel: "",
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeRawMaterialOptions: [],
      typeMeasureOptions: [],
      groupProductOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list

        for (let group of this.groupProductOptions) {
          for (let item of group.options) {
            item.checked = false
          }
        }

      }).catch(error => this.responseError(error))

      await typeMeasureService.selectList().then((list) => {
        this.typeMeasureOptions = list
      }).catch(error => this.responseError(error))

      await typeRawMaterialService.selectList().then((list) => {
        this.typeRawMaterialOptions = list
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

    },
    async onSubmit() {


      if (!this.form.availableAllGroups && this.form.groupsProduct.length === 0) {
        ui.msgError(this, "Você marcou a opção de especificar grupos para esta matéria-prima, porém não selecionou nenhum grupo. Desmarque a opção ou selecione pelo menos 1(um) grupo antes de continuar.")
      } else {
        await this.setSendingDefault()
      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    addGroupSelected(checked, id) {

      if (checked) {
        //Adicionar
        const el = this.form.groupsProduct.find(a => a.groupProductId === id)
        if (el == null)
          this.form.groupsProduct.push({groupProductId: id})
      } else {
        //Remover
        const indexRemove = this.form.groupsProduct.findIndex(a => a.groupProductId === id)

        if (indexRemove >= 0)
          this.form.groupsProduct.splice(indexRemove, 1)

      }

    },

    selectGroup(checked, array) {

      for (const el of array) {
        this.addGroupSelected(checked, el.value)
      }

    },

    onTypeRawMaterialDialog(itemInserted) {

      this.form.typeRawMaterialId = itemInserted.value
      this.typeRawMaterialOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
